<template>
  <div v-if="totalPages > 1" class="pagination-section">
    <div class="pagination-wrap">
      <button
        class="page-btn nav-btn"
        :disabled="currentPage === 0"
        @click="$emit('change-page', 0)"
      >
        &laquo;
      </button>

      <button
        class="page-btn nav-btn"
        :disabled="currentPageGroup === 0"
        @click="$emit('change-page', previousGroupPage)"
      >
        &lsaquo;
      </button>

      <button
        v-for="pageNo in visiblePages"
        :key="pageNo"
        class="page-btn number-btn"
        :class="{ active: pageNo === currentPage }"
        @click="$emit('change-page', pageNo)"
      >
        {{ pageNo + 1 }}
      </button>

      <button
        class="page-btn nav-btn"
        :disabled="currentPageGroup >= totalPageGroup"
        @click="$emit('change-page', nextGroupPage)"
      >
        &rsaquo;
      </button>

      <button
        class="page-btn nav-btn"
        :disabled="currentPage === totalPages - 1"
        @click="$emit('change-page', totalPages - 1)"
      >
        &raquo;
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaginationBar',

  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    groupSize: {
      type: Number,
      default: 5,
    },
  },

  computed: {
    currentPageGroup() {
      return Math.floor(this.currentPage / this.groupSize)
    },

    totalPageGroup() {
      if (this.totalPages <= 0) return 0
      return Math.floor((this.totalPages - 1) / this.groupSize)
    },

    visiblePages() {
      const start = this.currentPageGroup * this.groupSize
      const end = Math.min(start + this.groupSize, this.totalPages)
      const pages = []

      for (let i = start; i < end; i += 1) {
        pages.push(i)
      }

      return pages
    },

    previousGroupPage() {
      const page = (this.currentPageGroup - 1) * this.groupSize
      return page < 0 ? 0 : page
    },

    nextGroupPage() {
      const page = (this.currentPageGroup + 1) * this.groupSize
      return page >= this.totalPages ? this.totalPages - 1 : page
    },
  },
}
</script>

<style scoped>
@import "@/styles/admin/admin-pagination.css";
</style>